import React from "react";

type UseToggleAnimationProps = {
  toggleAnimation: boolean;
};

export const useToggleAnimation = ({
  toggleAnimation,
}: UseToggleAnimationProps) => {
  const [showAnimation, setShowAnimation] = React.useState(false);

  React.useEffect(() => {
    if (toggleAnimation) setShowAnimation(true);
  }, [toggleAnimation]);

  return { showAnimation, setShowAnimation };
};
